import { OfferSaleManager } from '../OfferSaleManager';
import { Headers } from '../types';
import { ApiClientFactory, ApiClientFactoryInterface } from './clients';

export class OfferSaleManagerFactory {
  private readonly apiClientFactory: ApiClientFactoryInterface;

  constructor(baseUrl: string, headers: Headers) {
    this.apiClientFactory = new ApiClientFactory(`${baseUrl}/api/v1/offer`, headers);
  }

  public createOfferSaleManager(token: string): OfferSaleManager {
    return new OfferSaleManager(this.apiClientFactory.createAuthorizedClient(token));
  }
}
